export default __webpack_public_path__ + "static/media/slider_inicio_3.373fb6a1.jpg";